/**
 * Checks if the clipboard-write permission is granted.
 * Handles different browser implementations and security considerations.
 * @returns {Promise<boolean>} True if permission is granted or prompt, false otherwise.
 */
export const checkClipboardPermission = async () => {
  if (!navigator.clipboard?.writeText) {
    return false; // Clipboard API isn't supported at all
  }

  if (!navigator.permissions?.query) {
    return true; // No Permissions API — assume OK, rely on try/catch at writing time
  }

  try {
    const permissionStatus = await navigator.permissions.query({
      name: 'clipboard-write'
    });

    return permissionStatus.state === 'granted' || permissionStatus.state === 'prompt';
  } catch (err) {
    // Firefox (and possibly others) don't support querying 'clipboard-write' —
    // this isn't a real denial, just an unsupported query. Assume it's usable.
    console.warn('Clipboard permission query unsupported, assuming available', err);
    return true;
  }
};
